<!-- SwipFx Orders Page - Filterable Order Book (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">

    <app-header [page]="'Accounts'"></app-header>
    <main class="container py-4">

        <!-- Header -->
        <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
            <div>
                <h4 class="mb-0 fw-bold">Profile</h4>
                <div class="text-muted small">Manage your personal details, security, and KYC</div>
            </div>
            <div class="d-flex gap-2">
                <button class="btn btn-outline-secondary btn-sm">Back</button>
                <button class="btn btn-primary btn-sm">Save changes</button>
            </div>
        </div>

        <!-- ERROR -->
        <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

        <!-- LOADING SKELETON -->
        <div *ngIf="loading && !userData" class="card shadow-sm border-0">
            <div class="card-body p-4">
                <div class="placeholder-glow">
                    <div class="placeholder col-4 mb-2"></div>
                    <div class="placeholder col-7 mb-4"></div>
                    <div class="placeholder col-12 mb-2"></div>
                    <div class="placeholder col-10 mb-2"></div>
                    <div class="placeholder col-8"></div>
                </div>
            </div>
        </div>

        <div *ngIf="userData" class="row g-3">

            <!-- Left: Summary card -->
            <div class="col-12 col-lg-4">
                <div class="card shadow-sm border-0">
                    <div class="card-body p-4">
                        <div class="d-flex align-items-center gap-3">
                            <div class="rounded-circle d-flex align-items-center justify-content-center"
                                style="width:56px; height:56px; background:#0b1f3a; color:#fff; font-weight:700;">
                                OA
                            </div>
                            <div>
                                <div class="fw-bold">{{userData.firstName}} {{userData.lastName}}</div>
                                <div class="text-muted small">{{userData.email}}</div>
                                <div class="small mt-1">
                                    <span class="badge text-bg-success">{{userData.status}}</span>
                                    <span class="badge text-bg-info ms-1">KYC: {{userData.kyc ?
                                        capitalize(userData.kyc.currentKycLevel) : 'Not Started'}}</span>
                                </div>
                            </div>
                        </div>

                        <hr class="my-4" />

                        <div class="small text-muted mb-2">Quick info</div>
                        <div class="d-flex justify-content-between py-1">
                            <div class="text-muted">Country</div>
                            <div class="fw-semibold">{{userData.country?.default?.name ?? 'Not specified'}}</div>
                        </div>
                        <div class="d-flex justify-content-between py-1">
                            <div class="text-muted">Phone</div>
                            <div class="fw-semibold">{{userData.phone}}</div>
                        </div>
                        <div class="d-flex justify-content-between py-1">
                            <div class="text-muted">Member since</div>
                            <div class="fw-semibold">{{userData.createdAt | date:'medium'}}</div>
                        </div>

                        <hr class="my-4" />

                        <div class="d-grid gap-2">
                            <button class="btn btn-outline-primary btn-sm"
                                type="button"
                                (click)="downloadAccountData()"
                                [disabled]="downloadingAccountData">
                                <span *ngIf="downloadingAccountData" class="spinner-border spinner-border-sm me-2"></span>
                                {{ downloadingAccountData ? 'Preparing download...' : 'Download account data' }}
                            </button>
                            <button class="btn btn-outline-danger btn-sm"
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#deactivateAccountModal"
                                (click)="prepareDeactivateAccount()">
                                Deactivate account
                            </button>
                            <button class="btn btn-danger btn-sm"
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#deleteAccountModal"
                                (click)="prepareDeleteAccount()">
                                Delete account permanently
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right: Tabs -->
            <div class="col-12 col-lg-8">
                <div class="card shadow-sm border-0">
                    <div class="card-body p-0">

                        <ul class="nav nav-tabs px-3 pt-3" role="tablist">
                            <li class="nav-item" role="presentation">
                                <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#tabPersonal"
                                    type="button" role="tab">
                                    Personal details
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tabCountryChange"
                                    type="button" role="tab">
                                    Country Change
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tabAccounts"
                                    type="button" role="tab">
                                    Accounts & passwords
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tabKyc" type="button"
                                    role="tab">
                                    KYC
                                </button>
                            </li>
                        </ul>

                        <div class="tab-content p-4">

                            <!-- Personal details -->
                            <div class="tab-pane fade show active" id="tabPersonal" role="tabpanel">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <div>
                                        <div class="fw-bold">Personal details</div>
                                        <div class="text-muted small">Keep your identity information up to date</div>
                                    </div>
                                    <a class="btn btn-outline-primary btn-sm" routerLink="/account/security">Manage security</a>
                                </div>

                                <div class="row g-3">
                                    <div class="col-md-6">
                                        <label class="form-label small text-muted">First name</label>
                                        <div class="form-control bg-light">{{userData.firstName}}</div>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label small text-muted">Last name</label>
                                        <div class="form-control bg-light">{{userData.lastName}}</div>
                                    </div>

                                    <div class="col-md-6">
                                        <label class="form-label small text-muted">Email</label>
                                        <div class="form-control bg-light">{{userData.email}}</div>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label small text-muted">Phone</label>
                                        <div class="form-control bg-light">{{userData.phone}}</div>
                                    </div>

                                    <div class="col-md-6">
                                        <label class="form-label small text-muted">Country</label>
                                        <div class="form-control bg-light">{{userData.country?.default?.name ?? 'Not specified'}}</div>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label small text-muted">Address</label>
                                        <div class="form-control bg-light">—</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Country change -->
                            <div class="tab-pane fade" id="tabCountryChange" role="tabpanel">
                                <div class="p-3">
                                    <div class="card shadow-sm border-0">
                                        <div class="card-body p-4">

                                            <div
                                                class="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-3">
                                                <div>
                                                    <h6 class="fw-bold mb-1">Country & Compliance Profiles</h6>
                                                    <div class="text-muted small">
                                                        Manage your current country and request a move to another
                                                        jurisdiction when needed.
                                                    </div>
                                                </div>

                                                <span class="badge text-bg-light border">
                                                    Current Country: {{ currentCountryName }}
                                                </span>
                                            </div>

                                            <div class="row g-3 mb-4">
                                                <div class="col-md-6">
                                                    <div class="border rounded p-3 h-100 bg-light-subtle">
                                                        <div class="small text-muted mb-1">Default Country</div>
                                                        <div class="fw-semibold">{{ userData.country?.default?.name ??
                                                            'N/A' }}</div>
                                                        <div class="small text-muted">{{ userData.country?.default?.code
                                                            ?? '—' }}</div>
                                                    </div>
                                                </div>

                                                <div class="col-md-6">
                                                    <div class="border rounded p-3 h-100 bg-light-subtle">
                                                        <div class="small text-muted mb-1">Compliance Profiles</div>
                                                        <div class="fw-semibold">{{ complianceProfiles.length }}</div>
                                                        <div class="small text-muted">Available jurisdiction profile(s)
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div *ngIf="hasPendingCountryChangeRequest"
                                                class="alert alert-warning border mb-4">
                                                <div
                                                    class="d-flex flex-wrap justify-content-between align-items-start gap-3">
                                                    <div>
                                                        <div class="fw-semibold mb-1">Pending country change request
                                                        </div>
                                                        <div class="small">
                                                            You already have a pending request and cannot submit another
                                                            one until it is resolved.
                                                        </div>

                                                        <div *ngIf="pendingRequest" class="small mt-2">
                                                            <div><span class="text-muted">Requested country:</span> {{
                                                                pendingRequest.requestedCountryCode }}</div>
                                                            <div><span class="text-muted">Product:</span> {{
                                                                pendingRequest.productType }}</div>
                                                            <div><span class="text-muted">Submitted:</span> {{
                                                                pendingRequest.createdAt | date:'medium' }}</div>
                                                        </div>
                                                    </div>

                                                    <button type="button" class="btn btn-outline-danger btn-sm"
                                                        (click)="cancelPendingCountryChange()"
                                                        [disabled]="cancellingCountryChange">
                                                        <span *ngIf="!cancellingCountryChange">Cancel Request</span>
                                                        <span *ngIf="cancellingCountryChange">Cancelling...</span>
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="mb-4">
                                                <div class="fw-semibold mb-2">Existing Compliance Profiles</div>

                                                <div *ngIf="!complianceProfiles.length"
                                                    class="text-muted small border rounded p-3">
                                                    No compliance profiles available yet.
                                                </div>

                                                <div class="row g-3" *ngIf="complianceProfiles.length">
                                                    <div class="col-md-6" *ngFor="let profile of complianceProfiles">
                                                        <div class="border rounded p-3 h-100">
                                                            <div
                                                                class="d-flex justify-content-between align-items-start mb-2">
                                                                <div>
                                                                    <div class="fw-semibold">{{ profile.jurisdictionCode
                                                                        }}</div>
                                                                    <div class="small text-muted">
                                                                        {{ profile.customerType }} • {{
                                                                        profile.productType }}
                                                                    </div>
                                                                </div>

                                                                <span class="badge"
                                                                    [ngClass]="profile.isActive ? 'text-bg-success' : 'text-bg-secondary'">
                                                                    {{ profile.isActive ? 'Active' : 'Inactive' }}
                                                                </span>
                                                            </div>

                                                            <div class="small">
                                                                <div><span class="text-muted">Tier:</span> {{
                                                                    profile.currentTierCode }}</div>
                                                                <div><span class="text-muted">Last approved:</span> {{
                                                                    profile.lastApprovedAt ? (profile.lastApprovedAt |
                                                                    date:'medium') : '—' }}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="border-top pt-4">
                                                <div class="fw-semibold mb-1">Request Country Change</div>
                                                <div class="text-muted small mb-3">
                                                    This request will be reviewed before any compliance jurisdiction
                                                    change is applied.
                                                </div>

                                                <div class="alert alert-info small">
                                                    Changing country may require a fresh KYC review depending on the
                                                    requested jurisdiction and product.
                                                </div>

                                                <form [formGroup]="countryChangeForm"
                                                    (ngSubmit)="submitCountryChange()">
                                                    <div class="row g-3">
                                                        <div class="col-12 col-md-4">
                                                            <label class="form-label small text-muted">Requested
                                                                Country</label>
                                                            <select class="form-select"
                                                                formControlName="requestedCountryCode"
                                                                [class.is-invalid]="countryChangeSubmitted && ccf['requestedCountryCode'].invalid">
                                                                <option value="">Select country</option>
                                                                <option *ngFor="let country of countries"
                                                                    [value]="country.code">
                                                                    {{ country.name }} ({{ country.code }})
                                                                </option>
                                                            </select>
                                                            <div class="invalid-feedback">Select a country</div>
                                                        </div>

                                                        <div class="col-12 col-md-4">
                                                            <label class="form-label small text-muted">Product</label>
                                                            <select class="form-select" formControlName="productType"
                                                                [class.is-invalid]="countryChangeSubmitted && ccf['productType'].invalid">
                                                                <option *ngFor="let product of productTypes"
                                                                    [value]="product">
                                                                    {{ product }}
                                                                </option>
                                                            </select>
                                                            <div class="invalid-feedback">Select a product</div>
                                                        </div>

                                                        <div class="col-12">
                                                            <label class="form-label small text-muted">Reason</label>
                                                            <textarea rows="4" class="form-control"
                                                                formControlName="reason"
                                                                [class.is-invalid]="countryChangeSubmitted && ccf['reason'].invalid"
                                                                placeholder="Example: I relocated to Canada and need my wallet compliance profile reviewed under Canadian requirements."></textarea>
                                                            <div class="invalid-feedback">
                                                                Please enter a reason between 5 and 500 characters
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="d-flex justify-content-end mt-3">
                                                        <button type="submit" class="btn btn-primary btn-sm"
                                                            [disabled]="submittingCountryChange || hasPendingCountryChangeRequest">
                                                            <span *ngIf="!submittingCountryChange">Submit Request</span>
                                                            <span *ngIf="submittingCountryChange">Submitting...</span>
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Accounts & passwords -->
                            <div class="tab-pane fade" id="tabAccounts" role="tabpanel">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <div>
                                        <div class="fw-bold">Accounts & passwords</div>
                                        <div class="text-muted small">Security settings for your account</div>
                                    </div>
                                    <button class="btn btn-outline-primary btn-sm">Edit</button>
                                </div>

                                <div class="list-group">
                                    <div class="list-group-item d-flex justify-content-between align-items-center">
                                        <div>
                                            <div class="fw-semibold">Password</div>
                                            <div class="text-muted small">Use a strong, unique password for your account.</div>
                                        </div>
                                        <a class="btn btn-outline-secondary btn-sm" routerLink="/auth/change-password">Change</a>
                                    </div>

                                    <div class="list-group-item d-flex justify-content-between align-items-center">
                                        <div>
                                            <div class="fw-semibold">Account PIN
                                                <span *ngIf="userData.accountPin?.isSet"
                                                    class="badge bg-success-subtle text-success border border-success-subtle">Enabled</span>
                                                <span *ngIf="!userData.accountPin?.isSet"
                                                    class="badge bg-secondary-subtle text-secondary border border-secondary-subtle">Not set</span>
                                            </div>
                                            <div class="text-muted small">Optional PIN login and deposit or withdrawal approvals.</div>
                                        </div>
                                        <a class="btn btn-outline-secondary btn-sm" routerLink="/account/security">
                                            {{ userData.accountPin?.isSet ? 'Manage' : 'Set up' }}
                                        </a>
                                    </div>

                                    <div class="list-group-item d-flex justify-content-between align-items-center">
                                        <div>
                                            <div class="fw-semibold">Two-factor authentication

                                                <span *ngIf="userData.otp?.otpEnabled"
                                                    class="badge bg-success-subtle text-success border border-success-subtle">
                                                    Enabled
                                                </span>
                                                <span *ngIf="!userData.otp?.otpEnabled"
                                                    class="badge bg-secondary-subtle text-secondary border border-secondary-subtle">
                                                    Disabled
                                                </span>
                                            </div>
                                            <div class="text-muted small">Add extra security to your account</div>
                                        </div>

                                        <button *ngIf="!userData.otp?.otpEnabled"
                                            class="btn btn-outline-secondary btn-sm" [routerLink]="['/account/2fa']">
                                            Enable
                                        </button>

                                        <button *ngIf="userData.otp?.otpEnabled" class="btn btn-outline-danger btn-sm"
                                            data-bs-toggle="modal" data-bs-target="#disable2faModal">
                                            Disable
                                        </button>
                                    </div>

                                    <div class="list-group-item d-flex justify-content-between align-items-center">
                                        <div>
                                            <div class="fw-semibold">Recovery codes</div>
                                            <div class="text-muted small">
                                                Use these if you lose your authenticator app.
                                                <span *ngIf="recoveryRemaining !== null" class="ms-1">
                                                    Remaining: <span class="fw-semibold">{{ recoveryRemaining }}</span>
                                                </span>
                                            </div>
                                        </div>

                                        <div class="d-flex gap-2">
                                            <button class="btn btn-outline-secondary btn-sm"
                                                (click)="openRecoveryModal()" [disabled]="!userData.otp?.otpEnabled">
                                                View / Generate
                                            </button>

                                            <button class="btn btn-outline-danger btn-sm"
                                                (click)="regenerateRecoveryCodes()"
                                                [disabled]="!userData.otp?.otpEnabled">
                                                Regenerate
                                            </button>
                                        </div>
                                    </div>

                                    <div class="list-group-item d-flex justify-content-between align-items-center">
                                        <div>
                                            <div class="fw-semibold">Active sessions</div>
                                            <div class="text-muted small">Manage devices logged into your account</div>
                                        </div>
                                        <button class="btn btn-outline-secondary btn-sm">View</button>
                                    </div>
                                </div>
                            </div>

                            <!-- KYC -->
                            <div class="tab-pane fade" id="tabKyc" role="tabpanel">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <div>
                                        <div class="fw-bold">KYC information</div>
                                        <div class="text-muted small">Verify your identity to unlock higher limits</div>
                                    </div>
                                </div>

                                <div class="row g-3">
                                    <div class="col-md-6">
                                        <div class="p-3 border rounded">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div class="fw-semibold">KYC Level</div>
                                                <span class="badge text-bg-info">{{userData.kyc ?
                                                    userData.kyc.currentKycLevel : 'Not Started'}}</span>
                                            </div>
                                            <div class="text-muted small mt-2" *ngIf="userData.kyc">
                                                Upgrade to {{capitalize(userData.kyc.nextKycLevel)}} to
                                                increase limits and enable more features.
                                            </div>
                                            <div class="text-muted small mt-2" *ngIf="!userData.kyc">
                                                To get started with your compliance verification, pleace visit the
                                                compliance center.
                                            </div>
                                            <div class="mt-3"
                                                *ngIf="userData.kyc && userData.kyc.nextKycLevel !== null">
                                                <button [routerLink]="['/compliance', 'start']"
                                                    class="btn btn-primary btn-sm">Start verification</button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="p-3 border rounded">
                                            <div class="fw-semibold">Compliance Center</div>
                                            <div class="text-muted small mt-2">The Compliance Center contains everything
                                                relating to KYC details and compliance</div>
                                            <div class="mt-3">
                                                <button [routerLink]="['/compliance']"
                                                    class="btn btn-outline-secondary btn-sm">Compliance Center</button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12" *ngIf="userData.kyc">
                                        <div class="p-3 border rounded">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <div class="fw-semibold">Status</div>
                                                <span
                                                    [class]="getKycApplicationStatusClass(userData.kyc.currentApplication.status)">{{userData.kyc.currentApplication.status}}</span>
                                            </div>
                                            <div *ngIf="userData.kyc.currentApplication.status !== 'Approved' && userData.kyc.currentApplication.status !== 'Rejected' && userData.kyc.currentApplication.status !== 'Expired'"
                                                class="text-muted small mt-2">
                                                We'll notify you by email once your verification is reviewed.
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>
        <app-footer></app-footer>
    </main>

</div>
<!-- Disable 2FA Modal -->
<div class="modal fade" id="disable2faModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 shadow">

            <div class="modal-header">
                <h5 class="modal-title fw-semibold">Disable Two-factor Authentication</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <form [formGroup]="disable2faForm" (ngSubmit)="disable2fa()">
                <div class="modal-body">
                    <div class="alert alert-warning py-2">
                        Disabling 2FA reduces account security. You’ll only need email/password to sign in.
                    </div>

                    <label class="form-label small text-muted">Authenticator code</label>
                    <input class="form-control form-control-lg text-center fw-bold" maxlength="6" inputmode="numeric"
                        placeholder="123456" formControlName="code"
                        [ngClass]="{ 'is-invalid': disable2faSubmitted && disable2faForm.invalid }" />

                    <div *ngIf="disable2faSubmitted && disable2faForm.invalid" class="invalid-feedback">
                        Enter a valid 6-digit code.
                    </div>

                    <div class="form-text">
                        If you lost your authenticator, use recovery codes (below) to regain access.
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal"
                        [disabled]="disabling2fa">
                        Cancel
                    </button>

                    <button type="submit" class="btn btn-danger" [disabled]="disabling2fa || disable2faForm.invalid">
                        <span *ngIf="disabling2fa" class="spinner-border spinner-border-sm me-2"></span>
                        Disable 2FA
                    </button>
                </div>
            </form>

        </div>
    </div>
</div>
<!-- Recovery Codes Modal -->
<div class="modal fade" id="recoveryCodesModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content border-0 shadow">

            <div class="modal-header">
                <h5 class="modal-title fw-semibold">Recovery codes</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>

            <div class="modal-body">
                <div class="alert alert-info py-2">
                    Save these somewhere safe. Each code can be used once.
                    We won't show them again after you close this dialog.
                </div>

                <div *ngIf="recoveryCodes.length" class="row g-2">
                    <div class="col-12 col-md-6" *ngFor="let c of recoveryCodes">
                        <div class="p-2 border rounded bg-body font-monospace fw-semibold text-center">
                            {{ c }}
                        </div>
                    </div>
                </div>

                <div *ngIf="!recoveryCodes.length" class="text-muted small">
                    Click “Generate” to create recovery codes.
                </div>
            </div>

            <div class="modal-footer">
                <button class="btn btn-outline-secondary" type="button" (click)="copyRecoveryCodes()"
                    [disabled]="!recoveryCodes.length">
                    Copy
                </button>

                <button class="btn btn-primary" type="button" (click)="generateRecoveryCodes()">
                    Generate
                </button>
            </div>

        </div>
    </div>
</div>

<!-- Deactivate Account Modal -->
<div class="modal fade" id="deactivateAccountModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 shadow">
            <div class="modal-header">
                <h5 class="modal-title fw-semibold">Deactivate account</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <form [formGroup]="deactivateAccountForm" (ngSubmit)="deactivateAccount()">
                <div class="modal-body">
                    <div class="alert alert-warning">
                        <div class="fw-semibold mb-1">Your account access will be paused immediately.</div>
                        <div class="small">
                            All sessions will be signed out and new account activity will be blocked. Your wallets,
                            transactions, and compliance records will remain intact. Contact support to reactivate the account.
                        </div>
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Current password</label>
                        <input class="form-control"
                            type="password"
                            formControlName="currentPassword"
                            autocomplete="current-password"
                            [class.is-invalid]="deactivateAccountSubmitted && deactivateAccountForm.get('currentPassword')?.invalid" />
                        <div class="invalid-feedback">Enter your current password.</div>
                    </div>

                    <div *ngIf="lifecycleRequiresTotp" class="mb-3">
                        <label class="form-label">Authenticator code</label>
                        <input class="form-control"
                            type="text"
                            inputmode="numeric"
                            maxlength="6"
                            formControlName="totpCode"
                            autocomplete="one-time-code"
                            placeholder="6-digit code"
                            [class.is-invalid]="deactivateAccountSubmitted && deactivateAccountForm.get('totpCode')?.invalid" />
                        <div class="invalid-feedback">Enter the six-digit code from your authenticator app.</div>
                    </div>

                    <div *ngIf="lifecycleRequiresAccountPin" class="mb-3">
                        <label class="form-label">Account PIN</label>
                        <input class="form-control"
                            type="password"
                            inputmode="numeric"
                            maxlength="6"
                            formControlName="accountPin"
                            autocomplete="off"
                            placeholder="6-digit PIN"
                            [class.is-invalid]="deactivateAccountSubmitted && deactivateAccountForm.get('accountPin')?.invalid" />
                        <div class="invalid-feedback">Enter your six-digit SwipFx account PIN.</div>
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Reason <span class="text-muted">(optional)</span></label>
                        <textarea class="form-control" rows="3" maxlength="500" formControlName="reason"
                            placeholder="Tell us why you are deactivating your account"></textarea>
                    </div>

                    <div>
                        <label class="form-label">Type <strong>DEACTIVATE</strong> to confirm</label>
                        <input class="form-control"
                            type="text"
                            formControlName="confirmation"
                            autocomplete="off"
                            [class.is-invalid]="deactivateAccountSubmitted && deactivateAccountForm.get('confirmation')?.invalid" />
                        <div class="invalid-feedback">Type DEACTIVATE to continue.</div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-outline-secondary" type="button" data-bs-dismiss="modal">Cancel</button>
                    <button class="btn btn-danger" type="submit" [disabled]="deactivatingAccount">
                        <span *ngIf="deactivatingAccount" class="spinner-border spinner-border-sm me-2"></span>
                        {{ deactivatingAccount ? 'Deactivating...' : 'Deactivate account' }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete Account Modal -->
<div class="modal fade" id="deleteAccountModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content border-0 shadow">
            <div class="modal-header">
                <h5 class="modal-title fw-semibold text-danger">Permanently delete account</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <form [formGroup]="deleteAccountForm" (ngSubmit)="deleteAccount()">
                <div class="modal-body">
                    <div class="alert alert-danger">
                        <div class="fw-semibold mb-1">This action cannot be undone.</div>
                        <div class="small">
                            Your sign-in profile and authentication information will be anonymized. Financial,
                            compliance, support, and audit records will remain retained where required.
                        </div>
                    </div>

                    <div *ngIf="checkingDeletionEligibility" class="border rounded p-3 text-center mb-3">
                        <span class="spinner-border spinner-border-sm me-2"></span>
                        Checking your account...
                    </div>

                    <div *ngIf="!checkingDeletionEligibility && !deletionEligibility"
                        class="border rounded p-3 mb-3">
                        <div class="small text-muted mb-2">We could not confirm deletion eligibility.</div>
                        <button class="btn btn-outline-secondary btn-sm" type="button"
                            (click)="loadDeletionEligibility()">
                            Try again
                        </button>
                    </div>

                    <div *ngIf="!checkingDeletionEligibility && deletionEligibility?.canDelete"
                        class="alert alert-success py-2">
                        Your account is eligible for permanent deletion.
                    </div>

                    <div *ngIf="!checkingDeletionEligibility && deletionEligibility && !deletionEligibility.canDelete"
                        class="account-delete-blockers border border-danger-subtle rounded p-3 mb-3">
                        <div class="fw-semibold text-danger mb-2">Complete these items first</div>
                        <ul class="mb-0 ps-3">
                            <li *ngFor="let blocker of deletionEligibility.blockers" class="mb-1">
                                {{ blocker.message }}
                            </li>
                        </ul>
                        <button class="btn btn-outline-secondary btn-sm mt-3" type="button"
                            (click)="loadDeletionEligibility()"
                            [disabled]="checkingDeletionEligibility">
                            Check again
                        </button>
                    </div>

                    <fieldset [disabled]="!deletionEligibility?.canDelete">
                        <div class="mb-3">
                            <label class="form-label">Current password</label>
                            <input class="form-control"
                                type="password"
                                formControlName="currentPassword"
                                autocomplete="current-password"
                                [class.is-invalid]="deleteAccountSubmitted && deleteAccountForm.get('currentPassword')?.invalid" />
                            <div class="invalid-feedback">Enter your current password.</div>
                        </div>

                        <div *ngIf="lifecycleRequiresTotp" class="mb-3">
                            <label class="form-label">Authenticator code</label>
                            <input class="form-control"
                                type="text"
                                inputmode="numeric"
                                maxlength="6"
                                formControlName="totpCode"
                                autocomplete="one-time-code"
                                placeholder="6-digit code"
                                [class.is-invalid]="deleteAccountSubmitted && deleteAccountForm.get('totpCode')?.invalid" />
                            <div class="invalid-feedback">Enter the six-digit code from your authenticator app.</div>
                        </div>

                        <div *ngIf="lifecycleRequiresAccountPin" class="mb-3">
                            <label class="form-label">Account PIN</label>
                            <input class="form-control"
                                type="password"
                                inputmode="numeric"
                                maxlength="6"
                                formControlName="accountPin"
                                autocomplete="off"
                                placeholder="6-digit PIN"
                                [class.is-invalid]="deleteAccountSubmitted && deleteAccountForm.get('accountPin')?.invalid" />
                            <div class="invalid-feedback">Enter your six-digit SwipFx account PIN.</div>
                        </div>

                        <div class="mb-3">
                            <label class="form-label">Reason <span class="text-muted">(optional)</span></label>
                            <textarea class="form-control" rows="3" maxlength="500" formControlName="reason"
                                placeholder="Tell us why you are deleting your account"></textarea>
                        </div>

                        <div>
                            <label class="form-label">Type <strong>DELETE</strong> exactly to confirm</label>
                            <input class="form-control"
                                type="text"
                                formControlName="confirmation"
                                autocomplete="off"
                                [class.is-invalid]="deleteAccountSubmitted && deleteAccountForm.get('confirmation')?.invalid" />
                            <div class="invalid-feedback">Type DELETE exactly to continue.</div>
                        </div>
                    </fieldset>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-outline-secondary" type="button" data-bs-dismiss="modal">Cancel</button>
                    <button class="btn btn-danger" type="submit"
                        [disabled]="deletingAccount || checkingDeletionEligibility || !deletionEligibility?.canDelete">
                        <span *ngIf="deletingAccount" class="spinner-border spinner-border-sm me-2"></span>
                        {{ deletingAccount ? 'Deleting...' : 'Delete permanently' }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

